import Button from "./Button";
import { Box, Typography } from "@mui/material";

const ListHeader = ({
  title,
  buttonText,
  buttonLink,
  buttonPathState,
  canAccess,
  permission,
  buttonIsNotVisible = false,
  buttonDisabled,
  extraButtons = [],
  onClickButton = () => {},
}) => {
  return (
    <Box className="mt-4 d-flex justify-content-between align-items-center">
      <Typography className="text-primary fw-bold text-uppercase text-sm mb-1">
        {title}
      </Typography>

      <Box className="d-flex gap-2">
        {canAccess(permission) &&
          !buttonIsNotVisible &&
          (!buttonDisabled && buttonLink ? (
            <Button
              text={buttonText}
              link={buttonLink}
              buttonPathState={buttonPathState}
            />
          ) : (
            <Button
              text={buttonText}
              disabled={buttonDisabled}
              onClick={onClickButton}
            />
          ))}

        {extraButtons.map((btn, idx) => {
          const canShow = btn.permission ? canAccess(btn.permission) : false;

          if (!canShow) return null;

          return (
            <Button
              key={idx}
              text={btn.text}
              link={!btn.disabled ? btn.link : undefined}
              disabled={btn.disabled}
              onClick={onClickButton}
              buttonPathState={btn.buttonPathState}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default ListHeader;
